module.exports = __webpack_public_path__ + "static/img/YY.82d6f423.png";